import { render, staticRenderFns } from "./SeoEdit.vue?vue&type=template&id=2870768d&scoped=true"
import script from "./SeoEdit.vue?vue&type=script&lang=js"
export * from "./SeoEdit.vue?vue&type=script&lang=js"
import style0 from "./SeoEdit.vue?vue&type=style&index=0&id=2870768d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2870768d",
  null
  
)

export default component.exports